import type { ISerialize } from '@/objects/ISerialize';

export class SignalrFileArchiveItemSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrFileArchiveItemSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrFileArchiveItemSubscribeParameters {
        return new SignalrFileArchiveItemSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrFileArchiveItemSubscribeParameters {
        return new SignalrFileArchiveItemSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrFileArchiveItemSubscribeParameters from another instance of SignalrFileArchiveItemSubscribeParameters.
     * @param other The SignalrFileArchiveItemSubscribeParameters you want to clone
     * @returns A cloned SignalrFileArchiveItemSubscribeParameters
     */
    public static FromOther(other: SignalrFileArchiveItemSubscribeParameters): SignalrFileArchiveItemSubscribeParameters {
        return SignalrFileArchiveItemSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrFileArchiveItemSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrFileArchiveItemSubscribeParameters';
}
